





































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import TabularHeader from '@/modules/shared/components/shared/TabularHeader.vue'
import { Prop } from 'vue-property-decorator'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AdminUserSwitchButton from '@/modules/user/components/admin/AdminUserSwitchButton.vue'

@Component({
  components: {
    AdminUserSwitchButton,
    BaseButton,
    TextEllipsis,
    DateTooltipped,
    TabularHeader
  }
})
export default class AdminUserTabularHeader extends Vue {
  @Prop({ required: true }) columns: TabularHeader['columns']
}
